import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetSyncStatuses as GetSyncStatusesQuery} from 'nutshell-graphql-types';

import GET_SYNC_STATUSES from '../../../integrations/graphql/queries/get-sync-statuses.graphql';

export const useGetCalendarSync = (skip = false) => {
    const {data, loading, refetch, error} = useQuery<GetSyncStatusesQuery, Record<any, any>>(
        GET_SYNC_STATUSES,
        {
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    const loggedInUser = data ? data.loggedInUser : null;
    const calendarSync = (loggedInUser && loggedInUser.calendarSync) || null;

    return {
        calendarSync,
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch: refetch,
    };
};
